import React, { useState, useEffect } from 'react';
import { useMonitoreo } from './MonitoreoContext';

import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

export default function LinearGraph() {
    const classes = useStyles();
    const [progress, setProgress] = useState(0);

    const { corridaActual, isCorridaActive, corridaRequiresLinea } = useMonitoreo();
    useEffect(() => {
        if (!corridaActual || !corridaActual.meta) {
            setProgress(0);
            return;
        }
        let porcent = (corridaActual.producido * 100) / corridaActual.meta;
        if (porcent > 100) {
            porcent = 100;
        }
        setProgress(porcent);
    }, [corridaActual]);

    const formatDate = (value) => {
        if (!value) return '';
        const d = new Date(value);
        return d.toLocaleString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    return (
        <div className="linearGraph-all">
            {corridaRequiresLinea ? (
                <h4 className="linearGraph-mensaje">Selecciona una línea para ver la corrida activa</h4>
            ) : isCorridaActive ? (
                <>
                    <div className="linearGraph-header">
                        <span><strong>Corrida actual:</strong> {corridaActual?.corrida}</span>
                        <span><strong>Orden:</strong> {corridaActual?.ordenProd}</span>
                    </div>
                    <div className="linearGraph">
                        <div className={classes.root}>
                            <LinearProgress variant="determinate" value={progress} />
                        </div>

                        <div className="linearGraph-text">
                            <h4>
                                {corridaActual.producido}/{corridaActual.meta}
                            </h4>
                        </div>
                    </div>
                    <div className="linearGraph-footer">
                        <span><strong>Fecha de inicio real:</strong> {formatDate(corridaActual?.fechaIniReal)}</span>
                    </div>
                    <div className="linearGraph-footer">
                        <span><strong>Producto:</strong> {corridaActual?.nombre}</span>
                    </div>
                    <div className="linearGraph-footer">
                        <span><strong>Fecha de finalización estimada:</strong> {formatDate(corridaActual?.fechaFinEstimada)}</span>
                    </div>
                </>
            ) : (
                <h4 className="linearGraph-mensaje">En el momento no hay corridas activas en esta línea</h4>
            )}
        </div>
    );
}
